import { useState } from "react";
import StaticPageLayout from "@/components/layout/StaticPageLayout";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const { language } = useLanguage();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      return toast.error(language === "hi" ? "कृपया सभी फ़ील्ड भरें।" : "Please fill in all fields.");
    }
    setBusy(true);
    setTimeout(() => {
      toast.success(language === "hi" ? "आपका संदेश भेज दिया गया है! हम जल्द ही आपसे संपर्क करेंगे।" : "Your message has been sent! We will contact you soon.");
      setName("");
      setEmail("");
      setMessage("");
      setBusy(false);
    }, 1000);
  };

  return (
    <StaticPageLayout
      title={language === "hi" ? "संपर्क करें" : "Contact Us"}
      subtitle={language === "hi" ? "हम हमेशा आपकी सहायता के लिए तैयार हैं" : "We are always here to help you"}
    >
      <div className="grid md:grid-cols-2 gap-10">
        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="c-name">{language === "hi" ? "आपका नाम" : "Your Name"}</Label>
            <Input id="c-name" value={name} onChange={(e) => setName(e.target.value)} placeholder={language === "hi" ? "नाम दर्ज करें" : "Enter your name"} className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="c-email">{language === "hi" ? "ईमेल पता" : "Email Address"}</Label>
            <Input id="c-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={language === "hi" ? "ईमेल दर्ज करें" : "Enter your email"} className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="c-msg">{language === "hi" ? "आपका संदेश" : "Your Message"}</Label>
            <Textarea id="c-msg" value={message} onChange={(e) => setMessage(e.target.value)} placeholder={language === "hi" ? "यहाँ अपना संदेश लिखें..." : "Write your message here..."} rows={4} className="mt-1.5" />
          </div>
          <Button type="submit" disabled={busy} className="w-full rounded-full bg-primary text-white h-11 btn-press">
            {busy ? (language === "hi" ? "भेज रहा है..." : "Sending...") : (language === "hi" ? "संदेश भेजें" : "Send Message")}
          </Button>
        </form>

        {/* Contact Info */}
        <div className="space-y-6 lg:pl-10 border-l border-border/40">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-[#FAF6F7] flex items-center justify-center text-primary shrink-0">
              <Mail className="w-5 h-5" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground">{language === "hi" ? "ईमेल समर्थन" : "Email Support"}</h3>
              <p className="text-sm text-muted-foreground mt-1">info@hamarsathi.com</p>
            </div>
          </div>


          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-full bg-[#FAF6F7] flex items-center justify-center text-primary shrink-0">
              <MapPin className="w-5 h-5" />
            </div>
            <div>
              <h3 className="font-semibold text-foreground">{language === "hi" ? "मुख्यालय कार्यालय" : "Headquarters Office"}</h3>
              <p className="text-sm text-muted-foreground mt-1">Hazaribagh, Jharkhand, India - 825301</p>
            </div>
          </div>
        </div>
      </div>
    </StaticPageLayout>
  );
}
